import React from 'react';

export type TavernFieldProps = {
  /** Field label text */
  label: string;
  /** Whether the field is required */
  required?: boolean;
  /** Error message to display below the field */
  error?: string | null;
  /** Hint text to display below the field (shown when no error) */
  hint?: string;
  /** Field input/control element */
  children: React.ReactNode;
  /** Additional CSS class for the field container */
  className?: string;
};

/**
 * Reusable form field component with label, error, and hint support.
 * Used across form pages for consistent field styling.
 *
 * @example
 * <TavernField label="Name" required error={nameError}>
 *   <input type="text" className="ttbInput" />
 * </TavernField>
 */
export function TavernField({
  label,
  required,
  error,
  hint,
  children,
  className,
}: TavernFieldProps) {
  return (
    <div className={`ttbField${className ? ` ${className}` : ''}`}>
      <div className={`ttbFieldLabel${required ? ' ttbFieldLabel-required' : ''}`}>
        {label}
      </div>
      {children}
      {error ? (
        <div className="ttbFieldError">{error}</div>
      ) : hint ? (
        <div className="ttbFieldHint">{hint}</div>
      ) : null}
    </div>
  );
}
